import configurationProcess from './configuration-process';

const route = {
	path: ':codeProject/template',
	name: 'page-template',
	meta: {
		title: 'Template',
	},
	props: true,
	component: () => import('@/pages/template/page-template'),
	children: [
		{
			name: 'page-template-detail',
			path: ':id/detail',
			meta: {
				title: 'Detalle template',
			},
			component: () => import('@/pages/template/page-template-detail'),
			props: true,
		},
		{
			path: ':id/new',
			name: 'page-template-new',
			meta: {
				title: 'Nuevo Template',
			},
			component: () => import('@/pages/template/page-template-new'),
			props: true,
		},
		{
			path: 'clone',
			name: 'page-template-clone',
			meta: {
				title: 'Clonar Template',
			},
			component: () => import('@/pages/template/page-template-clone'),
			props: true,
		},
		{
			path: ':idTemplate/resources-assignment',
			name: 'page-resources-assignment',
			meta: {
				title: 'Asignación de recursos',
			},
			component: () => import('@/pages/template/page-resources-assignment'),
			props: true,
		},
		{
			path: ':idDistribution/distribution-resource',
			name: 'page-distribution-of-resources',
			meta: {
				title: 'Distribuidor de Recursos - Empresas',
			},
			component: () => import('@/pages/template/page-distribution-of-resources'),
			props: true,
		},
		{
			path: ':id/edit-name',
			name: 'page-template-edit',
			meta: {
				title: 'Editar Nombre',
			},
			component: () => import('@/pages/template/page-template-edit-name'),
			props: true,
		},
		configurationProcess,
	],
};

export default route;



// WEBPACK FOOTER //
// ./src/router/template.js